// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"357":"61fbf9c0","441":"ce86d827","722":"420ae530","954":"68054200"}[chunkId] + ".chunk.js";
};